import { render, staticRenderFns } from "./order-cancellation.vue?vue&type=template&id=43fc197b&"
import script from "./order-cancellation.vue?vue&type=script&lang=js&"
export * from "./order-cancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports